import * as z from "zod";

export const setTemuIntegrationSettings = {
  name: "setTemuIntegrationSettings" as const,
  input: z.object({
    omsEnabled: z.boolean(),
    returnsEnabled: z.boolean(),
    isUsingRedoReturnLabels: z.boolean(),
  }),
  output: z.null(),
};
